import axios from "@/axios/axios";
import {ProjectServiceDocument, ServiceDocument} from "@/interfaces/service.interfaces";

export async function fetchServices(accid: string): Promise<ServiceDocument[]> {
  try {
    const res = await axios.get(`/masterserv/account/${accid}`)
    return res ? res.data : []
  } catch (e: any) {
    console.log('fetchServices :', e.message);
    return []
  }
}

export async function getProjectService(prjid: string, serviceid: string): Promise<ProjectServiceDocument | null> {
  try {
    const res = await axios.get(`/service/project/${serviceid}/${prjid}`);
    return res ? res.data : null;
  } catch (e: any) {
    console.log('getProjectService :', e.message);
    return null;
  }
}

export async function addProjectService(docProjectService: Omit<ProjectServiceDocument, '_id'>): Promise<boolean> {
  try {
    const res = await axios.post(`/service/project/add`, docProjectService);
    return !!res && res.status === 200
  } catch (e: any) {
    console.log('addProjectService :', e.message);
    return false;
  }
}

export async function updateProjectService(projectServiceId: string, payload: Partial<ProjectServiceDocument>): Promise<boolean> {
  try {
    const res = await axios.put(`/service/project/${projectServiceId}`, payload);
    return !!res && res.status === 200
  } catch (e: any) {
    console.log('updateProjectService :', e.message);
    return false;
  }
}
